import { api } from "../../lib";

export interface PhysicianReportDelivery {
  id: string;
  physicianId: string;
  reportDeliveryMethodId: string;
  email: string | null;
  phone: string | null;
  fax: string | null;
  address: string | null;
  hl7Host?: string | null;
  hl7Port?: number | null;
  hl7Facility?: string | null;
  hl7ApplicationId?: string | null;
  remoteConnectionIdentifier?: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  physician?: { firstName: string; lastName: string } | null;
  reportDeliveryMethod?: { id: string; name: string } | null;
  // snake_case aliases for backward compatibility
  physician_id?: string;
  report_delivery_method_id?: string;
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
  report_delivery_method?: { name: string } | null;
}

export interface CreatePhysicianReportDeliveryInput {
  physicianId: string;
  reportDeliveryMethodId: string;
  email?: string | null;
  phone?: string | null;
  fax?: string | null;
  address?: string | null;
  isActive?: boolean;
  practiceId?: string | null;
  hl7Host?: string | null;
  hl7Port?: number | null;
  hl7Facility?: string | null;
  hl7ApplicationId?: string | null;
  remoteConnectionIdentifier?: string | null;
}

export interface UpdatePhysicianReportDeliveryInput
  extends Partial<CreatePhysicianReportDeliveryInput> {
  id: string;
}

// Normalize to have both camelCase and snake_case
function normalize(item: PhysicianReportDelivery): PhysicianReportDelivery {
  return {
    ...item,
    physician_id: item.physicianId,
    report_delivery_method_id: item.reportDeliveryMethodId,
    is_active: item.isActive,
    created_at: item.createdAt,
    updated_at: item.updatedAt,
    report_delivery_method: item.reportDeliveryMethod,
  };
}

export const physicianReportDeliveryService = {
  getAll: async () => {
    const items = await api.get<PhysicianReportDelivery[]>(
      "/admin/physician-report-delivery"
    );
    return items.map(normalize);
  },

  getByPhysicianId: async (physicianId: string) => {
    const items = await api.get<PhysicianReportDelivery[]>(
      `/admin/physicians/${physicianId}/report-delivery-methods`
    );
    return items.map(normalize);
  },

  getById: async (id: string) => {
    const item = await api.get<PhysicianReportDelivery>(
      `/admin/physician-report-delivery/${id}`
    );
    return normalize(item);
  },

  create: async (input: CreatePhysicianReportDeliveryInput) => {
    const item = await api.post<PhysicianReportDelivery>(
      "/admin/physician-report-delivery",
      input
    );
    return normalize(item);
  },

  update: async (input: UpdatePhysicianReportDeliveryInput) => {
    const { id, ...updates } = input;
    const item = await api.put<PhysicianReportDelivery>(
      `/admin/physician-report-delivery/${id}`,
      updates
    );
    return normalize(item);
  },

  toggleActive: async (id: string) => {
    const item = await api.patch<PhysicianReportDelivery>(
      `/admin/physician-report-delivery/${id}/toggle-active`
    );
    return normalize(item);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/physician-report-delivery/${id}`);
  },
};
